import React, { Component } from 'react'
import { injectIntl, defineMessages } from 'react-intl'
import Select from 'react-select'
import { AppContext, Features } from '@lightspeed-invoicing/core-client/frontend'

const messages = defineMessages({
    "placeholder": {
        id: 'common.calendar.select.placeholder',
        defaultMessage: 'Select a calendar',
    },
})

class ExternalCalendarSelect extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            userId: this.props.userId || '',
            options: [{
                value: '',
                label: this.props.intl.formatMessage(messages.placeholder),
            }],
            selectedOption: this.props.value || null,
            calendarIntegration: this.props.calendarIntegration || null,
            disabled: this.props.disabled || false,
        }

        const defaultCallback = () => { }
        this.name = this.props.name || 'calendar-select'
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOption: selectedOption
        }, () => {
            if (selectedOption) {
                this.onChange(selectedOption.value, selectedOption.label)
            } else {
                this.onChange('', '')
            }
        });
    }

    componentDidMount() {
        this.loadExternalCalendars()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            selectedOption: nextProps.value,
        })
        
        if (!this.state.calendarIntegration && nextProps.calendarIntegration) {
            this.setState({
                calendarIntegration: nextProps.calendarIntegration
            }, () => {
                this.loadExternalCalendars()
            })
        }
    }

    loadExternalCalendars() {
        if (this.state.calendarIntegration) {
            AppContext.getApiClient().get(
                `/${this.state.calendarIntegration.attributes.integrationKey}/${this.state.calendarIntegration.attributes.configuration.accountId}/external-calendars`)
                .then((res) => {
                    if (res.data) {
                        this.setState({
                            options: this.state.options.concat(res.data.map(calendar => {
                                return {
                                    value: calendar.id,
                                    label: calendar.name,
                                }
                            }))
                        })
                    }
                })
        }
    }

    render() {
        return (
            <Select
                name={this.name}
                placeholder={this.placeholder || this.props.intl.formatMessage(messages.placeholder)}
                value={this.state.selectedOption}
                onChange={this.handleChange}
                options={this.state.options}
                clearable={false}
                searchable={false}
                disabled={this.state.disabled}
            />
        )
    }
}

export default injectIntl(ExternalCalendarSelect)





// WEBPACK FOOTER //
// ./src/calendar/externalcalendarselect.component.jsx